module.exports = __webpack_public_path__ + "static/img/19-0919_2.0b15c20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/19-0919_2.jpg
// module id = r+Mr
// module chunks = 0